import request from '@/utils/request'

// 조회
export function getRiskAssessmentsName (params,isProgress) {
  return request({
    url: `/api/getRiskAssessmentsName`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
// 저장
export function saveRiskAssessmentImentation (params, isProgress) {
  return request({
    url: `/api/saveRiskAssessmentImentation`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 저장
export function getRiskAssessmentImplementationReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: `/api/getRiskAssessmentImplementationReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 이행 초기화
export function initializedImplementation (params, isProgress) {
  return request({
    url: `/api/initializedImplementation`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' },
  })
}